var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('fob-aboutme-list-options',{attrs:{"resourceType":_vm.resourceType}}),_vm._v(" "),_c('fob-aboutme-list-compact',{attrs:{"resourceType":_vm.resourceType}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1dc62ec9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/aboutme/AboutMeListView.vue
// module id = XsV+
// module chunks = 1